var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75736 8C4.68074 7.07662 6.05502 6.88366 7.16998 7.41581L11.2524 3.33337C11.4086 3.17716 11.6624 3.17716 11.8187 3.33337L12.6666 4.18135C12.8228 4.33756 12.8228 4.59138 12.6666 4.74759L12.331 5.08318L12.755 5.50717C12.9112 5.66338 12.9112 5.9172 12.755 6.07341L12.7025 6.12589C12.5463 6.2821 12.2925 6.2821 12.1363 6.12589L11.7123 5.7019L11.0936 6.32062L11.5176 6.74461C11.6738 6.90082 11.6738 7.15464 11.5176 7.31085L10.8464 7.98205C10.6902 8.13826 10.4364 8.13826 10.2801 7.98205L9.85616 7.55806L8.58419 8.83002C9.11634 9.94498 8.92338 11.3193 8 12.2426C6.82843 13.4142 4.92893 13.4142 3.75736 12.2426C2.58579 11.0711 2.58579 9.17157 3.75736 8ZM4.46447 10.1213C4.07394 10.5118 4.07394 11.145 4.46447 11.5355C4.85499 11.9261 5.48816 11.9261 5.87868 11.5355C6.2692 11.145 6.2692 10.5118 5.87868 10.1213C5.48816 9.7308 4.85499 9.7308 4.46447 10.1213Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpKey);
export default __webpack_public_path__ + "static/media/otp-key.60132ebaa17c357b6b5e23aac9073340.svg";
export { ForwardRef as ReactComponent };